/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { BranchTypesService } from '../../branch-types/logic/branch-types.service';
import { BranchesService } from '../../branches/logic/branches.service';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { LoggingService } from '../../logging/logic/logging.service';
import { TourStopsService } from '../../tour-stop/logic/tour-stop.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';

/**
 * Visibility Service checks for given Rules if something is visible
 */
@Injectable({
  providedIn: 'root',
})
export class HasVIPOnTourVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'hasVIPOnTour';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private tourStopsService: TourStopsService,
    private branchesService: BranchesService,
    private branchTypesService: BranchTypesService,
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    let tourId = this.clientStateService.theState.getValue().tourId;

    if (tourId == undefined) {
      return false;
    }

    let tourStops = this.tourStopsService.getTourStopsByTourId(tourId);

    return tourStops
      .map((tourStop) => tourStop.branchIds)
      .reduce((prev, curr) => {
        for (const id of curr) {
          prev.push(id);
        }
        return prev;
      }, [])
      .map((id) => this.branchesService.getBranchById(id))
      .map((branch) => {
        return this.branchTypesService.getBranchTypeById(
          branch?.branchType?.id,
        );
      })
      .map((branchType) => {
        return branchType?.isVip;
      })
      .reduce((prev, curr) => prev || curr, false);
  }

  // Private Functions
}
